import { render, staticRenderFns } from "./FotoFrente.vue?vue&type=template&id=fdd348c4&scoped=true&"
import script from "./FotoFrente.vue?vue&type=script&lang=js&"
export * from "./FotoFrente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdd348c4",
  null
  
)

export default component.exports